var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 12.045",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.364 10.472 2.52 6.983l.781-.64L5.44 8.97l7.17-7.17.71.71z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/selected.6160273486beac2b0499f64953f71173.svg";